import {
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import ZaraButton from '../custom-components/buttons/Button';
import { useMutation } from '@apollo/client';
import { ChangePhoneNumberWhileRegistration } from '../../graphql/mutations/ChangePhoneNumberWhileRegistration';
import { useError } from '../../error-provider/ErrorProvider';
import PhoneInput from 'react-phone-input-2';
import { countries } from '../../utils/constants';
import { useUserData } from '../../context/UserDataProvider';

const RefreshPhone = ({ isOpen, onClose, isNew = false }) => {
    const { showError } = useError();
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const toast = useToast();

    // Get email from useUserData
    const { userData } = useUserData();
    const email = userData?.user_info?.email || '';

    const [refreshPhone] = useMutation(ChangePhoneNumberWhileRegistration, {
        onError(error) {
            showError(undefined, error);
        },
    });
    const phone = userData?.user_info?.phone_number || '';
    useEffect(() => {
        setValue(phone || '');
    }, [phone]);

    const onSubmit = async () => {
        if (value.replace(/\D/g, '').length < 10) {
            setError('Phone number must be at least 10 digits.');
            return;
        }
        setError('');
        try {
            await refreshPhone({
                variables: {
                    email: email ?? '',
                    phoneNumber: value,
                },
                onCompleted(data) {
                    if (data.changePhoneNumberWhileRegistration.__typename === 'SuccessType') {
                        toast({
                            status: 'success',
                            title: data.changePhoneNumberWhileRegistration.message,
                            isClosable: true,
                        });
                    } else {
                        toast({
                            status: 'error',
                            title: data.changePhoneNumberWhileRegistration.message,
                            isClosable: true,
                        });
                    }
                },
            });
        } catch (error) {
            console.log(error);
        } finally {
            onClose();
        }
    };

    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose} motionPreset='slideInBottom'>
            <ModalOverlay />
            <ModalContent minW={{ base: '200px', sm: '448px' }}>
                <ModalHeader>{isNew ? 'Add Phone Number' : 'Change phone number'}</ModalHeader>
                <ModalBody>
                    <PhoneInput
                        inputStyle={{ width: '100%' }}
                        placeholder='Write your new phone number'
                        enableSearch={true}
                        onlyCountries={countries}
                        country={'us'}
                        inputProps={{ required: true }}
                        value={value}
                        onChange={(e) => {
                            setValue(e);
                            if (e.replace(/\D/g, '').length !== 11) {
                                setError('Phone number must be at least 10 digits.');
                            } else {
                                setError('');
                            }
                        }}
                    />
                    {error && (
                        <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>
                    )}
                </ModalBody>
                <ModalFooter p='16px 24px'>
                    <Flex alignItems='center' justifyContent={{ base: 'space-between', sm: 'flex-end' }} w='100%'>
                        {!isNew && (<ZaraButton onClick={onClose} mr='12px' variant='secondary'>
                            Cancel
                        </ZaraButton>)}
                        <ZaraButton isDisabled={!value.trim() || value.replace(/\D/g, '').length < 10} onClick={onSubmit}>
                            Save
                        </ZaraButton>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default RefreshPhone;
